import {Alert, Box, Button, Modal, SpaceBetween} from "@cloudscape-design/components";


export const DeleteWithConfirmation = ({visible, onDiscard, onConfirm, title, modalContent, alertContent, isPerformingAction}) => {
    return (
        <Modal
            visible={visible}
            onDismiss={onDiscard}
            header={title}
            closeAriaLabel="Close dialog"
            footer={
                <Box float="right">
                    <SpaceBetween direction="horizontal" size="xs">
                        <Button variant="link" onClick={onDiscard} disabled={isPerformingAction}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={onConfirm} data-testid="submit" loading={isPerformingAction}>
                            Delete
                        </Button>
                    </SpaceBetween>
                </Box>
            }
        >
            <SpaceBetween size="m">
                <Box variant="span">
                    {modalContent}
                </Box>

                <Alert>
                    {alertContent}
                </Alert>
            </SpaceBetween>
        </Modal>
    )
}